import React from "react";
import "../styles/loading.scss";
import logo from '../img/sp-load.svg'
interface LoadingProps {
	height?: number;
	show?: boolean;
	isGlobalLoading?: boolean;
}

export default function LoadingOverlay({ height, show = false, isGlobalLoading =false }: LoadingProps) {
	if (show === true) {
		return (
			<div className="loading-overlay-new" style={{ height: `${height ? height + "px" : "100%"}` }}>
				<img className="loading-spinner" src={logo} alt="" />
				{isGlobalLoading && <p>Loading Commercial Vehical Insights</p>}
			</div>
		);
	} else {
		return null;
	}
}